<div id="welcome-popup">
  <div class="card-modal" 
       [style.max-width]="hasBannerConfig && bannerConfig && bannerConfig.size.maxWidth ? bannerConfig.size.maxWidth : '500px'"
       [style.width]="hasBannerConfig && bannerConfig && bannerConfig.size.width ? bannerConfig.size.width : '100%'">
    <div class="header" 
         [style.background-color]="hasBannerConfig && bannerConfig && bannerConfig.theme.primaryColor ? bannerConfig.theme.primaryColor : ''"
         [style.color]="hasBannerConfig && bannerConfig && bannerConfig.theme.headerTextColor ? bannerConfig.theme.headerTextColor : ''"
         [style.border-bottom]="hasBannerConfig && bannerConfig && bannerConfig.theme.secondaryColor ? ('10px solid ' + bannerConfig.theme.secondaryColor) : ''">
      <div class="case-name">
        <img *ngIf="hasBannerConfig && bannerConfig && getHeaderImageUrl()" 
             class="img-logo" 
             [src]="getHeaderImageUrl()" 
             alt="" />
      </div>
      <div class="case-steps">
        <div *ngIf="hasBannerConfig && bannerConfig && getHeaderDescriptionHtml()" [innerHTML]="getHeaderDescriptionHtml()"></div>
      </div>
    </div>
    <div class="body" 
         [style.color]="hasBannerConfig && bannerConfig && bannerConfig.theme.contentTextColor ? bannerConfig.theme.contentTextColor : ''">
      <div class="content-title">
        <p *ngIf="hasBannerConfig && bannerConfig && getContentTitle()">{{ getContentTitle() }}</p>
      </div>
      <div class="content-description">
        <div *ngIf="hasBannerConfig && bannerConfig && getContentDescriptionHtml()" [innerHTML]="getContentDescriptionHtml()"></div>
      </div>
    </div>

    <div class="footer" [class.footer--two-actions]="hasTutorialVideo">
      <button class="close-btn" 
              (click)="dialog.close()"
              [style.background-color]="hasBannerConfig && bannerConfig && bannerConfig.theme.contentTextColor ? bannerConfig.theme.contentTextColor : ''"
              [style.color]="hasBannerConfig && bannerConfig && bannerConfig.theme.buttonTextColor ? bannerConfig.theme.buttonTextColor : ''">
        <span *ngIf="hasBannerConfig && bannerConfig && getCtaLabel()">{{ getCtaLabel() }}</span>
      </button>

      <button
        *ngIf="hasTutorialVideo"
        class="tutorial-btn"
        (click)="openTutorialVideo()"
      >
        Assistir ao vídeo
      </button>
    </div>
  </div>
</div>


